import { useRouter, type RouteLocationRaw } from 'vue-router';

/**
 * Composable for smart navigation within the application.
 */
export function useNavigation() {
  const router = useRouter();

  /**
   * Navigates back to the previous page in history if it exists,
   * otherwise navigates to the provided fallback path.
   * 
   * @param fallback - The path or route object to navigate to if no history exists (default: '/')
   */
  const smartBack = (fallback: RouteLocationRaw = '/') => {
    // Check if there is a previous entry in the history stack within the app
    // window.history.state.back is populated by Vue Router 4 for internal navigations
    if (window.history.state && window.history.state.back) {
      router.back();
    } else {
      router.replace(fallback);
    }
  };

  return {
    smartBack,
    router
  };
}
